<template>
  <div class="ConceptosEditar">
    <md-layout md-flex="100" md-align="center">
      <md-layout md-flex-xsmall="100" md-flex-small="60" md-flex-medium="60" md-flex-large="40" md-flex-xlarge="30">

        <md-card class="w-100">
          <md-card-header>
            <div class="md-title">Registrar concepto de nómina</div>
            <div class="md-subhead">Los campos marcados con * son obligatorios</div>
          </md-card-header>
          <md-card-content>
            <md-layout md-flex="100" md-gutter="24">
              <md-layout md-column md-flex="100">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_desc }">
                  <label>Concepto</label>
                  <md-input v-model="concepto.desc_con" required></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-column md-flex="50">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_tipo }">
                  <label>Tipo</label>
                  <md-select name="tipo_con" id="tipo_con" v-model="concepto.tipo_con" required>
                    <md-option value="ingreso">Ingreso</md-option>
                    <md-option value="egreso">Egreso</md-option>
                  </md-select>
                </md-input-container>
              </md-layout>
              <md-layout md-column md-flex="50">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_importe }">
                  <label>Importe</label>
                  <md-input v-model="concepto.importe_cnh" type="number" min="0" step=".01" required></md-input>
                </md-input-container>
              </md-layout>
            </md-layout>
          </md-card-content>
          <md-card-actions>
            <router-link tag="md-button" to="/conceptos">Cancelar</router-link>
            <md-button class="md-accent md-primary" @click.native="guardarConcepto()">Guardar concepto</md-button>
          </md-card-actions>
        </md-card>
      </md-layout>
    </md-layout>
  </div>
</template>

<script>
  import sha1 from 'js-sha1'
  import md5 from 'blueimp-md5'
  import Snackbar from 'node-snackbar'
  export default {
    name: 'ConceptosEditar',
    methods: {
      guardarConcepto(){
        if(this.validarCamposConcepto()){
          this.$http.post('conceptos/guardar',{
            data : this.concepto,
            token: this.$session.get('token')
          })
          .then(response => {
            if (response.status === 200 && 'msg' in response.body) {
              Snackbar.show({
                text:'Bienvenido '+response.body.msg,
                actionText:'Cerrar',
                pos: 'top-right',
                showAction: false,
              });
              this.$router.push('/conceptos')
            }else{
              Snackbar.show({
                text: response.body.error,
                actionText:'Cerrar',
                showAction: false,
                pos: 'top-right',
                backgroundColor:'#F44336',
                actionTextColor:'#FFF'
              });
            }
          }, response => {
            Snackbar.show({
              text:'No se pudo establecer conexión con el servidor.',
              actionText:'Cerrar',
              showAction: false,
              pos: 'top-right',
              backgroundColor:'#F44336',
              actionTextColor:'#FFF'
            });
          });
        }
      },
      validarCamposConcepto(){
        !this.concepto.desc_con ? this.val.v_desc = true : this.val.v_desc = false
        !this.concepto.importe_cnh ? this.val.v_importe = true : this.val.v_importe = false
        !this.concepto.tipo_con ? this.val.v_tipo = true : this.val.v_tipo = false
        if(this.val.v_desc || this.val.v_importe || this.val.v_tipo){
          Snackbar.show({
            text:'Por favor llene todos los campos marcados con *',
            actionText:'Cerrar',
            showAction: false,
            pos: 'top-right',
            duration: 10000,
            backgroundColor:'#CC3D30',
            actionTextColor:'#FFF'
          });
          return false
        }else{
          return true
        }
      }
    },
    beforeCreate(){
      if (!this.$session.exists()) {
        this.$router.push('/login')
      }
    },
    data(){
      return {
        msg: 'Inicio',
        concepto: {
          desc_con: null,
          importe_cnh: null,
          tipo_con: null,
        },
        val: {
          v_desc: null,
          v_importe: null,
          v_tipo: null,
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ConceptosEditar.vue?fe1927de